<template>
  <b-row v-if="isEmpty(membership)">
    <b-col class="text-center">
      <b-alert show variant="info">
        Compila il modulo di ricerca e clicca sul tasto Dettaglio sul Cliente interessato.
      </b-alert>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col md="3">
      <b-card id="consensus-card" no-body>
        <template #header>
          <h5>
            <b-icon-patch-check/>&nbsp;Consensi forniti dal Cliente
          </h5>
        </template>
        <b-table id="consensus-table" hover :items="selectedConsensus" :fields="consensusTable"
                 style="margin-bottom: unset">
          <template #cell(isCheck)="data">
            <b-icon-check-square-fill v-if="data.item.isCheck"/>
            <b-icon-square v-else/>
          </template>
          <template #cell(consensus)="data">
            {{ data.item.consensus }}
          </template>
        </b-table>
      </b-card>
      <b-card v-if="modifiable" class="margin-top-md" header-bg-variant="light">
        <template #header>
          <h5>
            <b-icon-patch-check/>&nbsp;Azioni
          </h5>
        </template>
        <b-card-body style="padding: 0.5rem">
          <b-button block title="Ritenta invio" variant="danger" ref="send" v-on:click="sendToDitech">
            <b-icon icon="box-arrow-right" aria-hidden="true"/>
            Ritenta Invio
          </b-button>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col md="9">
      <b-card>
        <template #header>
          <div style="height: 1.5rem">
            <strong>
              <b-icon-person-badge/>&nbsp;Dettaglio adesione</strong>
          </div>
        </template>
        <b-card-body style="padding: 0.5rem">
          <b-form>
            <h6 class="heading-small text-muted mb-4">Dati personali</h6>
            <b-form-row>
              <b-col md="3">
                <b-form-group label-for="barcode-input" description="Codice Tessera Fedeltà">
                  <b-input-group>
                    <b-form-input id="barcode-input" :value="membership.barcode" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(membership.barcode)" variant="success" @click="editField('barcode')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label-for="old-barcode-input" description="Codice Tessera Fedeltà Precedente">
                  <b-input-group>
                    <b-form-input id="old-barcode-input" :value="membership.oldFidelityBarcode" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(membership.oldFidelityBarcode)" variant="success"
                                @click="editField('oldbarcode')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="6">
                <b-form-group label-for="full-name-input" description="Nome completo">
                  <b-input-group>
                    <b-form-input id="full-name-input" v-model="selectedFullName" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(selectedFullName)" variant="success" @click="editField('fullname')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group label-for="fiscal-code-input" description="Codice Fiscale">
                  <b-input-group>
                    <b-form-input id="fiscal-code-input" v-model="membership.personalData.fiscalCode"
                                  disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(membership.personalData.fiscalCode)" variant="success"
                                @click="editField('fiscalCode')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group label-for="sex-input" description="Sesso">
                  <b-form-input id="sex-input" v-model="membership.personalData.sex" disabled
                                class="text-center"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3">
                <b-form-group label-for="birth-date-input" description="Data di nascita">
                  <b-form-input id="birth-date-input" v-model="membership.personalData.birthDate"
                                disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="birth-place-input" description="Luogo di nascita">
                  <b-input-group>
                    <b-form-input id="birth-place-input" v-model="selectedBirthPlace" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="modifiable" variant="success" @click="editField('birthplace')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="12">
                <b-form-group label-for="residence-input" description="Indirizzo di residenza">
                  <b-input-group>
                    <b-form-input id="residence-input" v-model="selectedResidence" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(selectedResidence)" variant="success"
                                @click="editField('residence')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
            <hr>
            <h6 class="heading-small text-muted mb-4">Dati di contatto</h6>
            <b-form-row>
              <b-col md="4">
                <b-form-group label-for="email-input" description="E-mail">
                  <b-input-group>
                    <b-form-input id="email-input" v-model="membership.email" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(membership.email)" variant="success" @click="editField('email')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="mobile-phone-input" description="Numero di cellulare">
                  <b-input-group>
                    <b-form-input id="mobile-phone-input" v-model="membership.mobilePhone" disabled></b-form-input>
                    <b-input-group-append>
                      <b-button v-if="isModifiable(membership.mobilePhone)" variant="success"
                                @click="editField('mobilephone')">
                        <b-icon-pencil-fill></b-icon-pencil-fill>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="telephone-input" description="Numero di telefono">
                  <b-form-input id="telephone-input" v-model="membership.telephone" disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <hr>
            <h6 class="heading-small text-muted mb-4">Dati famigliari</h6>
            <b-form-row>
              <b-col md="1">
                <b-form-group label-for="family-number-input" description="Numero componenti famigliari">
                  <b-form-input id="family-number-input" v-model="membership.optionalData.familyNumber" disabled
                                class="text-center"></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="4">
                <b-form-group label-for="child1-birth-date-input" description="Data di nascita del primogenito">
                  <b-form-input id="child1-birth-date-input" v-model="membership.optionalData.sonDate1"
                                disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="child2-birth-date-input" description="Data di nascita del secondogenito">
                  <b-form-input id="child2-birth-date-input" v-model="membership.optionalData.sonDate2"
                                disabled></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label-for="child3-birth-date-input" description="Data di nascita del terzogenito">
                  <b-form-input id="child3-birth-date-input" v-model="membership.optionalData.sonDate3"
                                disabled></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-form>
        </b-card-body>
      </b-card>
    </b-col>

    <b-modal id="edit-barcode" title="Modifica il valore" @ok="setBarcode" ok-title="Salva" cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <b-form-group label="Codice Tessera Fedeltà">
        <b-form-input
          id="barcode"
          name="Tessera"
          v-model="modals.barcode"
          v-validate="{ min: 13, max: 13, numeric: true, regex: /^0229|0206/, required: true}"
          :state="stateValidation('Tessera')"
          aria-describedby="input-barcode-feedback"
        />
        <b-form-invalid-feedback id="input-barcode-feedback">
          {{ veeErrors.first('Tessera') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal id="edit-oldbarcode" title="Modifica il valore" @ok="setOldBarcode" ok-title="Salva" cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <b-form-group label="Codice Tessera Fedeltà Precedente">
        <b-form-input
          id="oldBarcode"
          v-model="modals.oldBarcode"
          name="Vecchia Tessera"
          v-validate="{ min: 13, max: 13, numeric: true, regex: /^0229|0206/, required: true}"
          :state="stateValidation('Vecchia Tessera')"
          aria-describedby="input-oldbarcode-feedback"
        />
        <b-form-invalid-feedback id="input-oldbarcode-feedback">
          {{ veeErrors.first('Vecchia Tessera') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal id="edit-fullname" title="Modifica il valore" @ok="setFullName" ok-title="Salva" cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <b-form-group label="Nome">
        <b-form-input
          id="firstName"
          v-model="modals.firstName"
          name="Nome"
          v-validate="{ min: 1, max: 25, required: true}"
          :state="stateValidation('Nome')"
          aria-describedby="input-firstname-feedback"
        />
        <b-form-invalid-feedback id="input-firstname-feedback">
          {{ veeErrors.first('Nome') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Cognome">
        <b-form-input
          id="lastName"
          name="Cognome"
          v-model="modals.lastName"
          v-validate="{ min: 1, max: 25, required: true }"
          aria-describedby="input-lastname-feedback"
          :state="stateValidation('Cognome')"
        />
        <b-form-invalid-feedback id="input-lastname-feedback">
          {{ veeErrors.first('Cognome') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal id="edit-fiscalCode" title="Modifica il valore" @ok="setFiscalCode" ok-title="Salva" cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <b-form-group label="Codice Fiscale">
        <b-form-input
          id="fiscalCode"
          name="Codice Fiscale"
          v-model="modals.fiscalCode"
          v-validate="{regex: /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/, required: true}"
          :state="stateValidation('Codice Fiscale')"
          aria-describedby="input-fiscalCode-feedback"
        />
        <b-form-invalid-feedback id="input-fiscalCode-feedback">
          {{ veeErrors.first('Codice Fiscale') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal size="xl" id="edit-birthplace" title="Modifica il valore" @ok="save" ok-title="Salva"
             cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <BirthPlaceSelect :value="modals" @birthplace-edited="setBirthPlace"
                        event-name="birthplace-edited"></BirthPlaceSelect>
    </b-modal>

    <b-modal size="xl" id="edit-residence" title="Modifica il valore" @ok="save" ok-title="Salva" cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <ResidenceSelect :value="modals" @residence-edited="setResidence"
                       event-name="residence-edited"></ResidenceSelect>
    </b-modal>

    <b-modal id="edit-email" title="Modifica il valore" @ok="setEmail" ok-title="Salva" cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <b-form-group label="Email">
        <b-form-input
          id="email"
          v-model="modals.email"
          name="Email"
          v-validate="{required: false, email: true}"
          aria-describedby="input-email-feedback"
          :state="stateValidation('Email')"
        />
        <b-form-invalid-feedback id="input-email-feedback">
          {{ veeErrors.first('Email') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <b-modal id="edit-mobilephone" title="Modifica il valore" @ok="setMobilePhone" ok-title="Salva"
             cancel-title="Annulla"
             hide-header-close no-close-on-backdrop>
      <b-form-group label="Numero di cellulare">
        <b-form-input
          id="mobilePhone"
          v-model="modals.mobilePhone"
          name="Numero di cellulare"
          v-validate="{required: false, regex: /^(\+)?[0-9\s]+$/}"
          aria-describedby="input-mobilephone-feedback"
          :state="stateValidation('Numero di cellulare')"
        />
        <b-form-invalid-feedback id="input-mobilephone-feedback">
          {{ veeErrors.first('Numero di cellulare') }}
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

  </b-row>
</template>

<script>
import MembershipApi from "@/api/MembershipApi";
import BirthPlaceSelect from "@/components/BirthPlaceSelect.vue";
import ResidenceSelect from "@/components/ResidenceSelect.vue";
import eventBus from "@/EventBus";

export default {
  name: "Details",
  components: {ResidenceSelect, BirthPlaceSelect},
  props: ['session', 'modifiable'],
  provide() {
    return {parentValidator: this.$validator}
  },
  data: () => ({
    membershipId: null,
    membership: {},
    consensusTable: [
      {key: 'isCheck', class: 'text-center small-column'},
      {key: 'consensus'}
    ],
    modals: {},
    saving: false,
    modified: {}
  }),
  beforeCreate() {
    eventBus.$on("membership-detail", (membershipId) => {
      this.membershipId = membershipId
      this.membershipDetails(membershipId)
    })
  },
  computed: {
    selectedFullName() {
      return `${this.membership.personalData.surname} ${this.membership.personalData.name}`
    },
    selectedBirthPlace() {
      if (this.isEmpty(this.membership)) return ""

      const {city, province, nation} = this.membership.personalData.birthPlace

      if (this.isEmpty(nation)) return `${city} (${province})`
      else if (this.isEmpty(city)) return `${nation} (${province})`
      else return `${city} (${province}) ${nation}`
    },
    selectedResidence() {
      if (this.isEmpty(this.membership)) return ""

      const {street, city, province, number, postalCode, nation} = this.membership.personalData.residence
      let code = postalCode != null ? postalCode : ""

      return `${street} n. ${number} ${city} ${code} (${province}) ${nation}`
    },
    selectedConsensus() {
      return [
        {isCheck: this.membership.consents.marketing, consensus: 'Marketing'},
        {isCheck: this.membership.consents.profiling, consensus: 'Profilazione'},
        {isCheck: this.membership.consents.cooperatives, consensus: 'Cooperazione'},
        {isCheck: this.membership.consents.thirdParty, consensus: 'Terze Parti'}
      ]
    }
  },
  methods: {
    membershipDetails(id) {
      MembershipApi
        .findBy(id)
        .then(result => this.membership = result.data)
        .then(() => this.setModified())
    },
    sendToDitech() {
      this.$bvModal.msgBoxConfirm("Quando si tenta l'invio, bisognerà attendere qualche secondo e ricaricare la pagina per vedere se è stata risolta la segnalazione", {
        title: 'Tentare l\'invio per risolvere la segnalazione?',
        headerBgVariant: 'dark',
        headerTextVariant: 'light',
        headerCloseVariant: 'light',
        okVariant: 'danger',
        okTitle: 'Tenta invio',
        cancelTitle: 'Annulla',
        cancelVariant: 'light',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(agreed => {
          if (agreed) MembershipApi.postMembershipToDitech(this.membershipId)
        })
    },
    setModified() {
      this.modals = {
        barcode: this.membership.barcode,
        oldBarcode: this.membership.oldFidelityBarcode,
        firstName: this.membership.personalData.name,
        lastName: this.membership.personalData.surname,
        fiscalCode: this.membership.personalData.fiscalCode,
        residenceStreet: this.membership.personalData.residence.street,
        residenceCivicNumber: this.membership.personalData.residence.number,
        residenceTown: this.membership.personalData.residence.city,
        residencePostalCode: this.membership.personalData.residence.postalCode,
        residenceProvince: this.membership.personalData.residence.province,
        residenceNation: this.membership.personalData.residence.nation,
        birthPlaceTown: this.membership.personalData.birthPlace.city,
        birthPlaceProvince: this.membership.personalData.birthPlace.province,
        birthPlaceNation: this.membership.personalData.birthPlace.nation,
        email: this.membership.email,
        mobilePhone: this.membership.mobilePhone
      }
    },
    setResidence(event) {
      this.modified.residenceStreet = event.residenceStreet
      this.modified.residenceCivicNumber = event.residenceCivicNumber
      this.modified.residenceTown = event.residenceTown
      this.modified.residencePostalCode = event.residencePostalCode
      this.modified.residenceProvince = event.residenceProvince
      this.modified.residenceNation = event.residenceNation
    },
    setBirthPlace(event) {
      this.modified.birthPlaceTown = event.birthPlaceTown
      this.modified.birthPlaceProvince = event.birthPlaceProvince
      this.modified.birthPlaceNation = event.birthPlaceNation
    },
    setFullName() {
      this.modified.firstName = this.modals.firstName
      this.modified.lastName = this.modals.lastName

      this.save()
    },
    setBarcode() {
      this.modified.barcode = this.modals.barcode

      this.save()
    },
    setOldBarcode() {
      this.modified.oldBarcode = this.modals.oldBarcode

      this.save()
    },
    setEmail() {
      this.modified.email = this.modals.email

      this.save()
    },
    setMobilePhone() {
      this.modified.mobilePhone = this.modals.mobilePhone

      this.save()
    },
    setFiscalCode() {
      this.modified.fiscalCode = this.modals.fiscalCode

      this.save()
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) return !this.veeErrors.has(ref)
      else return null
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.saving = true
          MembershipApi.update(this.membership.id, this.modified)
            .then(() => this.saving = false)
            .then(() => this.membershipDetails(this.membershipId))
            .then(() => this.modified = {})
        } else {
          this.modified = {}
        }
      })
    },
    editField(field) {
      this.$bvModal.show(`edit-${field}`)
    },
    isEmpty(object) {
      return object === null
    },
    isModifiable(value) {
      return this.modifiable && value && value !== ""
    }
  }
}
</script>
